import { Injectable } from '@angular/core';

declare var jQuery: any;

@Injectable()
export class AlertService {
  constructor() {}

  alert_status_success(message: string, strong: string = '', display_permanently: boolean = false) {
    var alerter = jQuery('#alert_status');
    strong = strong || '';
    alerter.html('<div class="alert alert-success"><strong>' + strong + '</strong>' + (strong ? '&nbsp;' : '') + message + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
    if (!display_permanently)
      window.setTimeout(() => {
        this.alert_status_clear();
      }, 5000);
  }
  alert_status_warning(message: string, strong: string = '', display_temporarily: boolean = false) {
    var alerter = jQuery('#alert_status');
    strong = strong || '';
    alerter.html('<div class="alert alert-warning"><strong>' + strong + '</strong>' + (strong ? '&nbsp;' : '') + message + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
    if (display_temporarily)
      window.setTimeout(() => {
        this.alert_status_clear();
      }, 5000);
  }
  alert_status_danger(message: string, strong: string = '') {
    var alerter = jQuery('#alert_status');
    strong = strong || '';
    alerter.html('<div class="alert alert-danger"><strong>' + strong + '</strong>' + (strong ? '&nbsp;' : '') + message + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
  }
  alert_status_info(message: string, strong: string = '') {
    var alerter = jQuery('#alert_status');
    strong = strong || '';
    alerter.html('<div class="alert alert-info"><strong>' + strong + '</strong>' + (strong ? '&nbsp;' : '') + message + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
  }
  alert_status_clear() {
    var alerter = jQuery('#alert_status');
    alerter.html('');
  }
  alert_status_success_center(message: string, strong: string = '') {
    var alerter = jQuery('#alert_status_center');
    strong = strong || '';
    alerter.css('display', 'block');
    alerter.html('<div class="alert alert-success"><strong>' + strong + '</strong>' + (strong ? '&nbsp;' : '') + message + '</div>');
  }
  alert_status_warning_center(message: string, strong: string = '') {
    var alerter = jQuery('#alert_status_center');
    strong = strong || '';
    alerter.css('display', 'block');
    alerter.html('<div class="alert alert-warning"><strong>' + strong + '</strong>' + (strong ? '&nbsp;' : '') + message + '</div>');
  }
  alert_status_danger_center(message: string, strong: string = '') {
    var alerter = jQuery('#alert_status_center');
    strong = strong || '';
    alerter.css('display', 'block');
    alerter.html('<div class="alert alert-danger"><strong>' + strong + '</strong>' + (strong ? '&nbsp;' : '') + message + '</div>');
  }
  alert_status_info_center(message: string, strong: string = '') {
    var alerter = jQuery('#alert_status_center');
    strong = strong || '';
    alerter.css('display', 'block');
    alerter.html('<div class="alert alert-info"><strong>' + strong + '</strong>' + (strong ? '&nbsp;' : '') + message + '</div>');
  }
  alert_status_clear_center() {
    var alerter = jQuery('#alert_status_center');
    alerter.css('display', 'none');
    alerter.html('');
  }
  set_overlay_global(active: boolean) {
    if (active) jQuery('#overlay_global').css('width', '100%').css('height', '100%');
    else jQuery('#overlay_global').css('width', '0%').css('height', '0%');
  }
  alert_status_success_overlay(message: string, strong: string = '') {
    this.set_overlay_global(true);
    this.alert_status_success_center(message, strong);
  }
  alert_status_warning_overlay(message: string, strong: string = '') {
    this.set_overlay_global(true);
    this.alert_status_warning_center(message, strong);
  }
  alert_status_danger_overlay(message: string, strong: string = '') {
    this.set_overlay_global(true);
    this.alert_status_danger_center(message, strong);
  }
  alert_status_info_overlay(message: string, strong: string = '') {
    this.set_overlay_global(true);
    this.alert_status_info_center(message, strong);
  }
  alert_status_clear_overlay() {
    this.set_overlay_global(false);
    this.alert_status_clear_center();
  }
}
